var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06366 3.37724C6.16838 3.32488 6.2903 3.319 6.39958 3.36102L11.6605 5.38445L16.5064 3.3653C16.6172 3.31913 16.7426 3.323 16.8503 3.37592C16.9581 3.42884 17.0378 3.52567 17.069 3.6416L19.9857 14.4749C20.0147 14.5829 19.9992 14.698 19.9425 14.7944C19.8859 14.8908 19.7929 14.9604 19.6844 14.9875L13.0177 16.6541C12.9514 16.6707 12.882 16.6707 12.8156 16.6541L6.25719 15.0145L0.531137 16.6506C0.399547 16.6882 0.257886 16.6587 0.152147 16.5718C0.0464087 16.485 -0.00992317 16.3517 0.00144202 16.2153L0.834775 6.21532C0.846851 6.07041 0.933602 5.94227 1.06366 5.87724L6.06366 3.37724ZM1.64578 6.51788L5.83333 4.4241V14.269L0.881971 15.6836L1.64578 6.51788ZM12.431 15.699L6.66667 14.2579V4.3566L11.283 6.13211L12.431 15.699ZM13.2742 15.7311L19.0707 14.2819L16.388 4.31744L12.118 6.09657L13.2742 15.7311Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.100e9ee0a7a14c2a5570faf8a5ff0665.svg";
export { ForwardRef as ReactComponent };